import Vue from 'vue'
import Router from 'vue-router'

import wellness_coupon from '@/components/wellness-coupon'
import redeem_coupon from '@/components/redeem-coupon'
import ambassador_invite from '@/components/ambassador-invite'
import download_app from '@/components/download-app'
import heals_home from '@/components/heals-home'
Vue.use(Router)

export default new Router({
  base:'/heals/',
  mode: 'history',
  routes: [
    {
      path: '/wellness/coupon/:token/',
      name: 'wellness-coupon',
      component: wellness_coupon
    },
    {
      path: '/redeem/coupon/:token/',
      name: 'redeem-coupon',
      component: redeem_coupon
    },
    {
      path: '/ambassador/invite/:inviteCode/',
      name: 'ambassador-invite',
      component: ambassador_invite
    },
    {
      path:'/download/healsapp',
      name:'download-healsapp',
      component:download_app
    },
    {
      path:'/CKH',
      name:'heals-home',
      component:heals_home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js